(function customChartModuleDefinition() {
    'use strict';

    angular.module('CustomChart', ['googlechart'])
        .directive('customChart', ['errorsExtend',
            function (errors) {
                return {
                    scope: {
                        data: "=ngModel",
                    },

                    controller: [
                        '$scope', '$element', function ($scope, $element) {

                            $scope.data = {
                                options: {
                                    title: "",
                                    width: 0,
                                    height: 0
                                },
                                rows: [{
                                    c: [
                                       { v: "" },
                                       { v: 0 }
                                    ]
                                },
                                {
                                    c: [
                                       { v: "" },
                                       { v: 0 }
                                    ]
                                }]
                            }

                            $scope.$watch("data", function (newValue, oldValue) {
                                if ($scope.data) {
                                    var chart = {};

                                    chart.type = "PieChart";
                                    chart.data = {

                                        "cols": [
                                            { id: "col1-id", label: "Column1", type: "string" },
                                            { id: "col2-id", label: "Column2", type: "number" }
                                        ], "rows": $scope.data.rows
                                    };

                                    chart.options = {
                                        "title": $scope.data.options.title,
                                        'width': $scope.data.options.width,
                                        'height': $scope.data.options.height,
                                        'slices': $scope.data.options.slices
                                    };


                                    chart.formatters = {};

                                    $scope.chart = chart;
                                }
                            });
                        }],
                    restrict: 'E',
                    templateUrl: '/app/directives/custom-chart/custom-chart.html',
                    link: function () {
                    }
                };
            }
        ]);
})();